export default __webpack_public_path__ + "static/media/thermometer.ff470699.png";